import { useState, useEffect } from 'react';
import { supabase } from '../config/supabase';

const useDashboardFilters = (userRole, fetchAdminDashboardData) => {
    // Tarih filtreleme - TransactionTracking ile aynı yapı
    const [startDate, setStartDate] = useState(() => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return today;
    });
    const [endDate, setEndDate] = useState(() => {
        const today = new Date();
        today.setHours(23, 59, 59, 999);
        return today;
    });

    // Navigation functions for date range
    const handlePreviousPeriod = () => {
        const diffTime = endDate.getTime() - startDate.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        const newStartDate = new Date(startDate);
        newStartDate.setDate(newStartDate.getDate() - diffDays);
        const newEndDate = new Date(endDate);
        newEndDate.setDate(newEndDate.getDate() - diffDays);

        setStartDate(newStartDate);
        setEndDate(newEndDate);
    };

    const handleNextPeriod = () => {
        const diffTime = endDate.getTime() - startDate.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        const newStartDate = new Date(startDate);
        newStartDate.setDate(newStartDate.getDate() + diffDays);
        const newEndDate = new Date(endDate);
        newEndDate.setDate(newEndDate.getDate() + diffDays);

        setStartDate(newStartDate);
        setEndDate(newEndDate);
    };

    // Tarih formatı
    const formatDate = (date) => {
        return date.toLocaleDateString('tr-TR', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    };

    const getDateRangeText = () => {
        return `${formatDate(startDate)} - ${formatDate(endDate)}`;
    };

    // Auto-refresh for admin dashboard
    useEffect(() => {
        if (userRole === 'admin') {
            const interval = setInterval(() => {
                fetchAdminDashboardData(startDate, endDate);
            }, 300000); // 5 minutes

            return () => clearInterval(interval);
        }
    }, [userRole, fetchAdminDashboardData, startDate, endDate]);

    // Realtime updates: refresh dashboard on sales changes
    useEffect(() => {
        if (userRole !== 'admin') return;

        const channel = supabase.channel('realtime-dashboard');

        const subscribeTable = (table) => {
            channel.on('postgres_changes', { event: '*', schema: 'public', table }, async () => {
                try {
                    await fetchAdminDashboardData(startDate, endDate);
                } catch (e) {
                    console.error(`Realtime refresh error for ${table}:`, e);
                }
            });
        };

        subscribeTable('sales');
        subscribeTable('car_sales');
        subscribeTable('balance_transactions');
        subscribeTable('daily_expenses');
        subscribeTable('cash_expenses');
        subscribeTable('service_transactions');

        channel.subscribe();

        return () => {
            try {
                supabase.removeChannel(channel);
            } catch { }
        };
    }, [userRole, startDate, endDate, fetchAdminDashboardData]);

    return {
        startDate,
        endDate,
        setStartDate,
        setEndDate,
        handlePreviousPeriod,
        handleNextPeriod,
        getDateRangeText,
        formatDate
    };
};

export default useDashboardFilters;
